module.exports = "<div role=\"main\" class=\"container\">\r\n\r\n  <vb-content-page-view\r\n    [actions]=\"actions\"\r\n    [hideActions]=\"true\">\r\n\r\n    <h1 page-title>Profil</h1>\r\n\r\n    <div page-content>\r\n\r\n      <form class=\"form-horizontal\">\r\n        <vb-profile-form\r\n          [item]=\"currentUser\">\r\n        </vb-profile-form>\r\n      </form>\r\n\r\n    </div>\r\n\r\n  </vb-content-page-view>\r\n\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/components/profile-view/profile-view.component.html
// module id = ./src/app/crm/components/profile-view/profile-view.component.html
// module chunks = main